import { render, staticRenderFns } from "./ProducedPopup.vue?vue&type=template&id=c60ca176&"
import script from "./ProducedPopup.vue?vue&type=script&lang=js&"
export * from "./ProducedPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports